import * as React from "react";
import * as Utils from "@Cyclope-Utils/index";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as Paths from "@tunnel-enums/index";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as cx from "classnames";
import * as Lodash from "lodash";
import * as Enums from "@tunnel-enums/index";
import SelectGrid from "@tunnel-components/@sharded/@widgets/select";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    loading,
    btnloading,
    sections,
    cameraAdded,
    nameCameraMaxLenghtBoolean,
    onGetSectionValue,
    onGetVueValue,
    onGetTypeValue,
    errorcamalreadyexist,
    nameCameraSynthaxBoolean,
    errorserversLoad,
    lessMore,
    ipCameraBoolean,
    streamBoolean,
    nameVueBoolean,
    nameTypeBoolean,
    nameCameraBoolean,
    nameSectionBoolean,
    projetCamera,
    proposedMaxDistance,
    directionCamera,
    lineaireLocalisationCamera,
    onLocaliZation,
    infrastructureCamera,
    onSubmit,
    errorserver,
    required,
    less,
    more,
    nameCamera,
    onChange,
    ipCamera,
    stream,
    proxyCode,
    intertube,
  } = props;
  /**
   * @description : recupère les rôles et les droits de l'utilisateur
   * @const
   * @type { objet }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.CAMERAADDED,
  ]);

  const handleChange = (e) => {
    const sanVal = e.currentTarget.value.replace(/[^a-zA-Z0-9]-_/g, "");
    e.currentTarget.value = sanVal;
    onChange(e);
  };


  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      btnloading={btnloading}
      error={errorserversLoad}
      loading={loading}
      snackbarError={less && !more}
      /* snackbar={!less && !more && cameraAdded}*/ someTextError={i18next.t(
        "La fin de couverture doit etre superieur au début de couverture"
      )}
    >
      <section className="tunnel-site animated fadeIn">
        <BreadCrumb
          iconSupervision={true}
          links1={Paths.PathsNamesEnums.CAMERAHOME}
          title={i18next.t("supervision")}
          breadText1={i18next.t("camera")}
          breadText2={i18next.t("ajout camera")}
        />
        <div className="contentAllSiteWithoutOnglet">
          <section className="columnsWithoutOnglet">
            <section className="content-wrapper">
              <section className="incident-items with-2-columns" id="columns">
                <div className="add-camera">
                  <li className="details-form">
                    <BoxGrid
                      title={i18next.t("description")}
                      classNames="boderShadow"
                    >
                      <Styled.CartContainer>
                        <span className="extractionInfo ">
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("nom camera")} : </h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput
                                error={
                                  nameCameraBoolean ||
                                  nameCameraMaxLenghtBoolean
                                }
                              >
                                <StyledComponent.Input
                                  type="text"
                                  name="nameCamera"
                                  value={nameCamera.toUpperCase()}
                                  disabled={!authorization}
                                  autoComplete="off"
                                  onChange={handleChange}
                                  maxLength={20}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                            {nameCameraSynthaxBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {" "}
                                {i18next.t("syntaxe invalide / champ vide")}
                              </span>
                            )}
                            {nameCameraMaxLenghtBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {" "}
                                {i18next.t("champ limite a 12 caracteres")}
                              </span>
                            )}
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("type")}: </h2>
                            <SelectGrid
                              style={{ height: "65px" }}
                              error={nameTypeBoolean}
                              vue={true}
                              selectedOptions={["Fixe", "Mobile"]}
                              onGetIdentifiantItem={onGetTypeValue}
                              placeholder={i18next.t("choisir le type")}
                            />
                            {nameTypeBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {i18next.t("champ obligatoire")}
                              </span>
                            )}
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("ip")} : </h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput
                                error={ipCameraBoolean}
                              >
                                <StyledComponent.Input
                                  autoComplete="off"
                                  placeholder="000.00.000.00"
                                  type="text"
                                  name="ipCamera"
                                  disabled={!authorization}
                                  value={ipCamera}
                                  onChange={onChange}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                            {ipCameraBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {i18next.t("syntaxe invalide")}
                              </span>
                            )}
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("stream")} : </h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput
                                error={streamBoolean}
                              >
                                <StyledComponent.Input
                                  autoComplete="off"
                                  type="text"
                                  name="stream"
                                  disabled={!authorization}
                                  value={stream}
                                  onChange={onChange}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                            {streamBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {i18next.t("champ obligatoire")}
                              </span>
                            )}
                          </div>                          
                        </span>
                        <span className="extractionInfo">
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("vue")} : </h2>
                            <SelectGrid
                              error={nameVueBoolean}
                              style={{ height: "65px" }}
                              vue={true}
                              selectedOptions={["approche", "fuite"]}
                              onGetIdentifiantItem={onGetVueValue}
                              placeholder={i18next.t("choisir la vue")}
                            />
                            {nameVueBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {i18next.t("champ obligatoire")}
                              </span>
                            )}
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("projet")} : </h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput
                                style={{ border: "none" }}
                              >
                                <StyledComponent.Input
                                  autoComplete="off"
                                  type="text"
                                  name="projetCamera"
                                  disabled={true}
                                  defaultValue={projetCamera}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("section")} : </h2>
                            <SelectGrid
                              style={{ height: "95px" }}
                              error={nameSectionBoolean}
                              section={true}
                              selectedOptions={sections}
                              onGetIdentifiantItem={onGetSectionValue}
                              placeholder={i18next.t("choisir la section")}
                            />
                            {nameSectionBoolean && (
                              <span
                                style={{
                                  color: "#ed5b56",
                                  fontSize: "10px",
                                  float: "right",
                                  marginTop: "5px",
                                }}
                              >
                                {" "}
                                {i18next.t("champ obligatoire")}
                              </span>
                            )}
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("proxyCode")} : </h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput>
                                <StyledComponent.Input
                                  autoComplete="off"
                                  type="text"
                                  name="proxyCode"
                                  disabled={!authorization}
                                  value={proxyCode}
                                  onChange={onChange}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                          </div>                            
                        </span>
                      </Styled.CartContainer>
                    </BoxGrid>
                    <div className="" style={{ width: "100%" }}>
                      <BoxGrid
                        title={i18next.t("infrastructure segmentation")}
                        classNames="boderShadow"
                      >
                        <Styled.CartContainer>
                          <span className="extractionInfo ">
                            <div className={cx("titleAction")}>
                              <h2>{i18next.t("infrastructure")} : </h2>
                              <StyledComponent.Container>
                                <StyledComponent.ContainerInput
                                  style={{ border: "none" }}
                                >
                                  <StyledComponent.Input
                                    autoComplete="off"
                                    type="text"
                                    name="infrastructureCamera"
                                    disabled={true}
                                    defaultValue={infrastructureCamera}
                                  />
                                </StyledComponent.ContainerInput>
                              </StyledComponent.Container>
                            </div>
                          </span>
                          <span className="extractionInfo ">
                            <div className={cx("titleAction")}>
                              <h2> {i18next.t("direction")} : </h2>
                              <StyledComponent.Container>
                                <StyledComponent.ContainerInput
                                  style={{ border: "none" }}
                                >
                                  <StyledComponent.Input
                                    autoComplete="off"
                                    type="text"
                                    name="directionCamera"
                                    disabled={true}
                                    defaultValue={
                                      !Lodash.isEqual(directionCamera, "") &&
                                      !Lodash.isUndefined(directionCamera)
                                        ? `${i18next.t("sens")}` +
                                          directionCamera
                                        : ""
                                    }
                                  />
                                </StyledComponent.ContainerInput>
                              </StyledComponent.Container>
                            </div>
                          </span>
                        </Styled.CartContainer>
                      </BoxGrid>
                    </div>
                  </li>
                  <li className="details-form">
                    <BoxGrid
                      title={i18next.t("localisation")}
                      classNames="boderShadow"
                      error={!authorization}
                      required={required || less || more}
                    >
                      <Styled.CartContainer>
                        <span className="extractionInfo ">
                          <div className={cx("titleAction")}>
                            <h2> {i18next.t("localisation lineaire")} :</h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput error={false}>
                                <StyledComponent.Input
                                  autoComplete="off"
                                  type="number"
                                  name="lineaireLocalisationCamera"
                                  disabled={!authorization}
                                  value={`${lineaireLocalisationCamera}` === "0" ? "" : `${lineaireLocalisationCamera}`}
                                  onChange={onLocaliZation}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                          </div>
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("distance max de detection")} : </h2>
                            <StyledComponent.Container>
                              <StyledComponent.ContainerInput
                                error={more || less || lessMore}
                              >
                                <StyledComponent.Input
                                  autoComplete="off"
                                  type="number"
                                  name="proposedMaxDistance"
                                  disabled={intertube}
                                  value={`${proposedMaxDistance}` === "0" ? "" : `${props.proposedMaxDistance}`}
                                  onChange={onLocaliZation}
                                />
                              </StyledComponent.ContainerInput>
                            </StyledComponent.Container>
                          </div>
                        </span>
                      </Styled.CartContainer>
                    </BoxGrid>
                    <div className="modalBtn" style={{ width: "98%" }}>
                      <span
                        className="btnPrimary "
                        style={{ overflow: "visible" }}
                        onClick={onSubmit}
                      >
                        {i18next.t("enregistrer")}
                      </span>
                    </div>
                  </li>
                </div>
              </section>
            </section>
          </section>
        </div>
      </section>

      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorserver}
        someTextSuccees={i18next.t("impossible de creer la camera")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorcamalreadyexist}
        someTextSuccees={i18next.t(
          "creation impossible, le nom de la camera existe deja"
        )}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={more && !less}
        someTextSuccees={i18next.t(
          "le debut de couverture doit être superieur  a la fin de couverture"
        )}
      />
      <SnackBar
        style={{ backgroundColor: "#00E1B3" }}
        isVisible={cameraAdded}
        someTextSuccees={i18next.t("la camera a ete creee")}
      />
    </LayoutGrid>
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  btnloading?: any;
  cameraAdded?: any;
  required?: any;
  sections?: any;
  sectionCamera?: any;
  projetCamera?: any;
  proposedMaxDistance?: any;
  directionCamera?: any;
  lineaireLocalisationCamera?: any;
  onLocaliZation?: any;
  infrastructureCamera?: any;
  onSubmit?: any;
  errorserver?: any;
  less?: any;
  more?: any;
  nameCamera?: any;
  typeCamera?: any;
  onChange?: any;
  ipCamera?: any;
  stream?: any;
  streamBoolean?: any;
  proxyCode?: any;
  intertube?: any;
  viewCamera?: any;
  errorserversLoad?: any;
  nameCameraBoolean?: boolean;
  nameSectionBoolean?: boolean;
  nameVueBoolean?: boolean;
  nameTypeBoolean?: boolean;
  lessMore?: boolean;
  ipCameraBoolean?: boolean;
  errorcamalreadyexist?: boolean;
  nameCameraMaxLenghtBoolean?: boolean;
  nameCameraSynthaxBoolean?: boolean;
  onGetTypeValue?: any;
  onGetVueValue?: any;
  onGetSectionValue?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/created/component.tsx